import { LocaleCode } from '@nuklear9/i18n';
import { MenuItem } from '@nuklear9/meta';
import { graphql, useStaticQuery } from 'gatsby';

import { buildMenu } from './build-menu';

export const useMetaMenu = (locale: LocaleCode): Array<MenuItem> => {
  const { drupalMetaMenu } = useStaticQuery<MetaMenuQuery>(graphql`
    query MetaMenu {
      drupalMetaMenu {
        translations {
          items {
            id
            url
            label
          }
          langcode
        }
      }
    }
  `);
  return drupalMetaMenu?.translations
    ? buildMenu(
        drupalMetaMenu?.translations?.find(
          (translation) => translation.langcode === locale,
        )?.items,
      )
    : [];
};
